import { format, parseISO } from 'date-fns';

import { PageEventFragment } from 'types/api/dato-operations.types';

const DEFAULT_ORGANIZATION_ID = 'MDLB';

export const formatEventDate = (date: string | undefined) => {
  if (!date) return '';
  return format(parseISO(date), 'yyyy-MM-dd');
};

type PageEventDatalayer = {
  eventId: string;
  hostingEventName: string;
  eventDate: string;
  eventOrganizerId: string;
};

export const mapPageEventToDatalayer = (
  event: Pick<PageEventFragment, 'id' | 'slug' | 'startDatetime'> | undefined,
): PageEventDatalayer =>
  event
    ? {
        eventId: event.id,
        hostingEventName: event.slug,
        eventDate: formatEventDate(event.startDatetime),
        eventOrganizerId: DEFAULT_ORGANIZATION_ID,
      }
    : ({} as PageEventDatalayer);
